define('home/models/SettingsEmailNotifications',[
    'core/config',

    'home/models/common/BaseSettings',
    'core/UniqueModel',
], function (
    config,

    BaseSettings,
    UniqueModel
) {
    'use strict';

    var SettingsEmailNotifications = BaseSettings.extend({
        url: config.urls.apiSettings + 'email/',

        toJSON: function () {
            return {
                'receive_notifications': this.get('receive_notifications'),
                'subscribe_thread_on_post': this.get('subscribe_thread_on_post'),
                'replies_to_comments': this.get('replies_to_comments'),
                'digest_frequency': this.get('digest_frequency'),
            };
        },

    }, {
        FREQUENCY_NEVER: 'never',
    });

    UniqueModel.addType('SettingsEmailNotifications', SettingsEmailNotifications);

    return SettingsEmailNotifications;
});


